// Preferencias por persona en localStorage (vistas, columnas, recientes). Todo acceso es tolerante a fallos.
export function leer<T>(clave: string, defecto: T): T {
  try {
    const v = localStorage.getItem(`upk-innova.${clave}`);
    return v ? (JSON.parse(v) as T) : defecto;
  } catch {
    return defecto;
  }
}

export function guardar(clave: string, valor: unknown): void {
  try {
    localStorage.setItem(`upk-innova.${clave}`, JSON.stringify(valor));
  } catch {
    /* sin almacenamiento */
  }
}
